export async function createEvento({ apiUrl, token, payload }) {
    const res = await fetch(`${apiUrl}/api/eventos/create`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Error guardando el evento.");
    }
    return res.json();
}

export async function updateEvento({ apiUrl, token, id, payload }) {
    const res = await fetch(`${apiUrl}/api/eventos/update/${id}`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Error guardando el evento.");
    }
    return res.json();
}
